import { SCREENS } from "../../data/site";

// Screenshot crop: screen area is x 148–716, y 168–1386 of the 864×1536 source.
const CROP = { width: "152.11%", height: "126.11%", left: "-26.06%", top: "-13.79%" };

export default function PhoneMockup({ idx }) {
  return (
    <div className="relative w-[244px] sm:w-[276px] lg:w-[292px]" data-testid="sutra-phone-mockup">
      <span aria-hidden className="absolute -left-[3px] top-[19%] h-8 w-[3px] rounded-l bg-[#2c2724]" />
      <span aria-hidden className="absolute -left-[3px] top-[27%] h-14 w-[3px] rounded-l bg-[#2c2724]" />
      <span aria-hidden className="absolute -left-[3px] top-[37%] h-14 w-[3px] rounded-l bg-[#2c2724]" />
      <span aria-hidden className="absolute -right-[3px] top-[30%] h-20 w-[3px] rounded-r bg-[#2c2724]" />
      <div className="rounded-[3rem] bg-[linear-gradient(150deg,#6b625b,#2a2522_35%,#3b3531_70%,#1c1917)] p-[3px] shadow-[0_50px_80px_-35px_rgba(43,38,32,0.55),0_20px_40px_-25px_rgba(43,38,32,0.4)]">
        <div className="rounded-[2.85rem] bg-[#0d0c0b] p-[9px]">
          <div className="relative aspect-[568/1218] overflow-hidden rounded-[2.3rem] bg-[#F7F4EE]">
            {SCREENS.map((s, i) => (
              <img
                key={s.id}
                src={s.src}
                alt={i === idx ? `Yoga Sutras app — ${s.label} screen` : ""}
                aria-hidden={i !== idx}
                loading="lazy"
                decoding="async"
                width="864"
                height="1536"
                data-testid={`sutra-screen-${s.id}`}
                data-active={i === idx}
                className="absolute max-w-none transition-opacity duration-700 ease-in-out"
                style={{ ...CROP, opacity: i === idx ? 1 : 0 }}
              />
            ))}
            <div aria-hidden className="pointer-events-none absolute inset-0 rounded-[2.3rem] bg-[linear-gradient(115deg,rgba(255,255,255,0.14),transparent_35%)]" />
          </div>
        </div>
      </div>
    </div>
  );
}
